import { environment } from 'src/environments/environment';
var IndividualMenu = [];
if (environment.includeDeviceDelivery) {

  IndividualMenu = [{
    id: 1,
    link: '/user/edit-details',
    text: 'Edit Details'
  },
    {
      id: 2,
      link: '/user/change-password',
      text: 'Change Password'
    },
    {
      id: 3,
      link: '/user/subscription',
      text: 'Subscription'
    },
    {
      id: 4,
      link: '/user/payment-method',
      text: 'Payment Method'
    },
    {
      id: 5,
      link: '/user/billing-history',
      text: 'Billing History'
    },
    {
      id: 6,
      link: '/user/replace-breathing-device',
      text: 'Replace Breathing Device'
    },
    {
      id: 7,
      link: '/user/delivery-address',
      text: 'Delivery Address'
    },
    // {
    //   id: 8,
    //   link: '/user/profile',
    //   text: 'Download eBook'
    // }
    {
      id: 8,
      link: '/delete-account',
      text: 'Delete Account'
    },
  ];

} else {

  IndividualMenu = [{
      id: 1,
      link: '/user/edit-details',
      text: 'Edit Details'
    },
    {
      id: 2,
      link: '/user/change-password',
      text: 'Change Password'
    },
    {
      id: 3,
      link: '/user/subscription',
      text: 'Subscription'
    },
    {
      id: 4,
      link: '/user/payment-method',
      text: 'Payment Method'
    },
    {
      id: 5,
      link: '/user/billing-history',
      text: 'Billing History'
    },
    {
      id: 6,
      link: '/delete-account',
      text: 'Delete Account'
    }];
}

export { IndividualMenu }
